import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sc-adv-search',
  templateUrl: './sc-adv-search.component.html',
  styleUrls: ['./sc-adv-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScAdvSearchComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() title: string;
  @Input() fields: any[];

  @Output() resultChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public search() {
    this.resultChange.emit(this.form.value);
  }
}
